import { CircularWrapper, Picture, PrintAndShare } from "/App.Components";
import { MetaInfoBlockProps } from "/Models/Generated/MetaInfoBlockProps";
import { PublishedAndUpdated } from "/App.Components";
import "./MetaInfoBlock.scss";

interface Props extends MetaInfoBlockProps {
  showPageMetadata?: boolean;
}

const MetaInfoBlock = ({
  publishedAndUpdated,
  author,
  printAndShare,
  showPageMetadata = true,
}: Props) => (
  <div className="meta-info-block-norad">
    {showPageMetadata && (
      <div className="meta-info-block-norad__published-and-updated-wrapper">
        <PublishedAndUpdated {...publishedAndUpdated} />
      </div>
    )}
    {author?.fullName && (
      <div className="meta-info-block-norad__author">
        {author?.image && (
          <CircularWrapper size="Small">
            <Picture {...author?.image} pictureBehaviour="Cover" />
          </CircularWrapper>
        )}
        <div className="meta-info-block-norad__author__text">
          <h3>{author?.fullName}</h3>
          <div className="meta-info-block-norad__author__text__section">
            {author?.jobTitle && <p>{author?.jobTitle}</p>}
            {author?.section && <p>{author?.section}</p>}
            {author?.email && <p>{author?.email}</p>}
          </div>
        </div>
      </div>
    )}
    {showPageMetadata && (
      <div className="meta-info-block-norad__print-and-share-wrapper">
        <PrintAndShare
          {...(printAndShare ?? {
            hidePrintButton: false,
            hideShareButton: false,
          })}
        />
      </div>
    )}
  </div>
);

export default MetaInfoBlock;
